import { Component, Input, OnChanges, SimpleChanges } from "@angular/core"

import { StudentAssignmentService } from "../../../services/student-assignment.service"
import { Question } from "../../../models/student-assignment/question.model"
import { QuestionSlideModel } from "../../../models/student-assignment/slide.model"

@Component({
    selector: "app-question-wizard",
    templateUrl: "./question-wizard.component.html",
    styleUrls: ["./question-wizard.component.scss"],
    standalone: false,
})
export class QuestionWizardComponent implements OnChanges {
    @Input() public questionsSlide: QuestionSlideModel
    @Input() public resultId: number = 0
    @Input() public preview: boolean = false
    public loading: boolean = true
    public currentPage: number = 0
    public questionsCount: number = 0
    public currentQuestion: Question
    public totalChars: number = 0
    public leftChars: number = 0

    constructor(public studentAssignmentService: StudentAssignmentService) {}

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.questionsSlide && changes.questionsSlide.currentValue) {
            this.questionsCount = this.questionsSlide.questions.length
            this.loading = false
            this.currentPage = this.questionsSlide.currentPage
            this.currentQuestion = this.questionsSlide.questions[this.currentPage - 1]
        }
    }

    public goToPage(nextPage: number) {
        if (this.currentPage !== nextPage && nextPage >= 0 && nextPage <= this.questionsCount) {
            this.currentPage = nextPage
            this.questionsSlide.currentPage = nextPage
            this.currentQuestion = this.questionsSlide.questions[this.currentPage - 1]
            this.totalChars = this.currentQuestion?.maxCount ? this.currentQuestion.maxCount : 250
            this.leftChars = this.currentQuestion?.userInput
                ? this.currentQuestion.userInput.length
                : 0
        }
        this.updatePaginationMarks()
    }

    public onNext() {
        this.goToPage(this.currentPage + 1)
    }

    public onPrev() {
        this.goToPage(this.currentPage - 1)
    }

    public onFirst(): void {
        this.goToPage(1)
    }

    public onLast(): void {
        this.goToPage(Math.ceil(this.questionsCount))
    }

    public submitAnswer() {
        if (!this.currentQuestion.hasAnswer()) {
            this.studentAssignmentService
                .submitAnswer(this.currentQuestion, this.resultId, this.preview)
                .subscribe((res) => {
                    if (this.preview) {
                        this.currentQuestion.userAnswer.correct = res.correct
                    } else {
                        this.currentQuestion.userAnswer = res
                        this.currentQuestion.userInput = this.currentQuestion.getAnswer()
                    }
                    this.updatePaginationMarks()
                })
        }
    }

    public isChecked(id) {
        if (this.currentQuestion.hasAnswer()) {
            return id === this.currentQuestion.getAnswerOption()
        }
        return false
    }

    public isLast() {
        return (
            this.currentQuestion.order >=
            this.questionsSlide.questions[this.questionsSlide.questions.length - 1].order
        )
    }

    public isCharLimitExceeded() {
        return this.leftChars > this.totalChars
    }

    public count() {
        if (this.currentQuestion.maxCount && this.currentQuestion?.userInput) {
            this.totalChars = this.currentQuestion.maxCount
            this.leftChars = this.currentQuestion.userInput.length
        } else {
            this.leftChars = 0
            this.totalChars = 0
        }
    }

    private updatePaginationMarks() {
        this.studentAssignmentService.updateMarks.next(true)
    }
}
